/* VoteReview.styles.tsx generated by @compiled/babel-plugin v0.36.0 */
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _13 = "._80om15jw{cursor:progress}";
const _12 = "._kqswh2mm{position:relative}";
const _11 = "._4t3i1j6v{height:1rem}";
const _10 = "._1bsb1j6v{width:1rem}";
const _9 = "._80omtlke{cursor:pointer}";
const _8 = "._18m915vq{overflow-y:hidden}";
const _7 = "._1reo15vq{overflow-x:hidden}";
const _6 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _5 = "._4cvr1h6o{align-items:center}";
const _4 = "._1bah1h6o{justify-content:center}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _ = "._zulputpp{gap:var(--ds-space-150,9pt)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ThumbsDownIcon from '@atlaskit/icon/core/thumbs-down';
import ThumbsUpIcon from '@atlaskit/icon/core/thumbs-up';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LikeFilledIcon = props => {
  const {
    label
  } = props;
  return /*#__PURE__*/_jsx(ThumbsUpIcon, {
    color: "var(--ds-icon-selected, #0C66E4)",
    label: label
  });
};
export const LikeOutlineIcon = iconProps => /*#__PURE__*/_jsx(ThumbsUpIcon, _objectSpread(_objectSpread({}, iconProps), {}, {
  color: "var(--ds-text-subtle, #44546F)"
}));
export const DislikeFilledIcon = props => {
  return /*#__PURE__*/_jsx(ThumbsDownIcon, _objectSpread(_objectSpread({}, props), {}, {
    color: "var(--ds-text-selected, #0C66E4)"
  }));
};
export const DislikeIcon = props => {
  return /*#__PURE__*/_jsx(ThumbsDownIcon, _objectSpread(_objectSpread({}, props), {}, {
    color: "var(--ds-text-subtle, #44546F)"
  }));
};
export const ReviewActionsContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulputpp _syaz1gjq _1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewActionsContainer.displayName = 'ReviewActionsContainer';
}
export const ReviewActionsOption = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _3, _5, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1b66 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _80omtlke", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewActionsOption.displayName = 'ReviewActionsOption';
}
export const SpinnerWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _10, _11, _12, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1h6o _1bsb1j6v _4t3i1j6v _kqswh2mm _80om15jw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SpinnerWrapper.displayName = 'SpinnerWrapper';
}